export default __webpack_public_path__ + "static/media/close.34cd2195.svg";